import aws4 from 'aws4';
import Config from 'Config';
import getCredentials from 'utils/getCredentials';

/**
 * Fetches a file from the files domain
 * @param {string} key - the key of the file to fetch
 * @param {file} file - not used in the function (some legacy code), some places in the code pass it to the function
 * @param {boolean} blobUrl - if true, returns a blob url
 * @param {boolean} blob - if true, returns a blob
 * @param {object} credentials - credentials object to use for the request
 * @returns
 */
const fetchFile = async (
  key,
  file,
  blobUrl = false,
  blob = false,
  credentials
) => {
  if (!credentials) credentials = await getCredentials();
  const { accessKeyId, secretAccessKey, sessionToken } = credentials;

  const filesDomain = process.env.REACT_APP_FILES_DOMAIN;

  let fixedKey;
  const folder1 = key.split('/')[0];
  const path = key.substr(key.indexOf('/') + 1).replace(/\//g, '_');
  fixedKey = folder1 + '/' + path;

  const payload = {
    getSignedUrl: true,
    key: fixedKey,
    //name: file.name,
  };
  const request = {
    host: filesDomain,
    path: fixedKey,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  const signer = new aws4.RequestSigner(request, {
    accessKeyId,
    secretAccessKey,
    sessionToken,
  });
  const signedRequest = signer.sign();
  signedRequest.headers.Accept = '*/*';
  signedRequest.cache = 'force-cache';
  let resp;
  try {
    const resp = await fetch(`https://${filesDomain}/${fixedKey}`, signedRequest);
    if (resp.status === 404) {
      console.log('File not found for:', fixedKey);
      return null; // Return null for non-existent files
    }

    const json = await resp.json();
    try {
      if (blobUrl) {
        const blob = await fetch(json.signedUrl).then((resp) => resp.blob()); // Create a blob from the response
        const url = URL.createObjectURL(blob);
        return url;
      }

      if (blob) {
        const blob = await fetch(json.signedUrl).then((resp) => resp.blob()); // Create a blob from the response
        return blob;
      }
      const fetchResponse = await fetch(json.signedUrl);
      if (fetchResponse.status === 200) {
        return json.signedUrl;
      } else {
        return null;
      }
    } catch (error) {
      console.log('error fetching file:', error);
    }
    // return json.signedUrl;
  } catch (e) {
    console.log('Error in fetchFile:', e);
    return null; // Return null when an error occurs
  }
};

export default fetchFile;
